import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=2f089c1a&scoped=true"
import script from "./CytomineViewer.vue?vue&type=script&lang=js"
export * from "./CytomineViewer.vue?vue&type=script&lang=js"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=2f089c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f089c1a",
  null
  
)

export default component.exports